import { AppBar, Tabs, Tab, makeStyles, Theme, createStyles } from "@material-ui/core";
import React from 'react';
import { SchedulingAnalysis } from "./components/ScheduleAnalysis";
import { readMonitorScheduler } from "@internal/backstage-plugin-supply-features-common";
import { usePermission } from '@backstage/plugin-permission-react';
import { ScheduleConfiguration } from "./components/ScheduleConfiguration";

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {

  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`nav-tabpanel-${index}`}
      aria-labelledby={`nav-tab-${index}`}
      {...other}
    >
      {children}
    </div>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    complementaryAppBar: {
      zIndex: 1009,
      marginBottom: theme.spacing(2)
    },
    tabs: {
      '& > div > span': {
        height: 4
      }
    }
  })
);

export const SystemSchedulerPage = () => {
  
  const [tabValue, setTabValue] = React.useState(0);
  const allowedReadMonitorPermission = usePermission({ permission: readMonitorScheduler }).allowed;
  const classes = useStyles();

  return (
    <>
      <AppBar position="sticky" role="complementary" className={classes.complementaryAppBar} >
        <Tabs className={classes.tabs}
          value={tabValue}
          onChange={(event, newValue) => setTabValue(newValue)}
          variant="fullWidth"
          centered
        >
          <Tab label="MONITORING" disabled={!allowedReadMonitorPermission}/>
          <Tab label="CONFIGURATION" />
        </Tabs>
      </AppBar>

      { allowedReadMonitorPermission && 
        <TabPanel value={tabValue} index={0}>
          { tabValue === 0 && <SchedulingAnalysis/>}
        </TabPanel>
      }

      <TabPanel value={tabValue} index={1}>
        { tabValue === 1 && <ScheduleConfiguration />}
      </TabPanel>
    </>
  );
};
